import { render, staticRenderFns } from "./LearningMaterials.vue?vue&type=template&id=1a096d10"
import script from "./LearningMaterials.vue?vue&type=script&lang=js"
export * from "./LearningMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports